var DelayBlockModel = /** @class */ (function () {
    function DelayBlockModel(data) {
        if (data === void 0) { data = undefined; }
        this.interval = 0;
        this.type = 'default';
        this.unit = 'Hours';
        this.condition = null;
        if (data) {
            for (var key in data) {
                if (this.hasOwnProperty(key)) {
                    this[key] = data[key];
                }
            }
        }
    }
    return DelayBlockModel;
}());
export { DelayBlockModel };
